import { useColorMode } from "@chakra-ui/color-mode";
import {
  Stack,
  useMediaQuery,
  Circle,
  Flex,
  Box,
  Text,
  Button,
  Image,
  IconButton,
  Link,
} from "@chakra-ui/react";
import { FaGithub, FaLinkedin, } from "react-icons/fa";
import React from "react";

const Header = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const [notSmallScreen] = useMediaQuery("(min-width: 600px)");
  const handleRedirect = () => {
    return (
      <Link
        href="https://dynamic-strudel-3a04dd.netlify.app/"
        isExternal
      ></Link>
    );
  };

  return (
    <Stack>
      <Circle
        position="absolute"
        bg="blue.100"
        opacity="0.1"
        w="300px"
        h="300px"
        alignSelf="flex-end"
      ></Circle>
      <Flex
        direction={notSmallScreen ? "row" : "column"}
        spacing="200px"
        p={notSmallScreen ? "32" : "0"}
        alignSelf="flex-start"
      >
        <Box mt={notSmallScreen ? "0" : 16} align="flex-start">
          <Text fontSize="5xl" fontWeight="semibold">
            Hii, I am
          </Text>
          <Text
            fontSize="7xl"
            fontWeight="bold"
            bgGradient="linear(to-r, cyan.400, blue.500, purple.600)"
            bgClip="text"
          >
            Ratnesh Pandey
          </Text>
          <Text fontSize="5xl" fontWeight="semibold">
            MERN Developer
          </Text>

          <Button
            ml={8}
            colorScheme="blue"
            mt={8}
            onClick={() =>
              window.open(
                "https://drive.google.com/file/d/1_pcpgZLipghutiP3ORdSfOy1pveSsb3X/view?usp=sharing"
              )
            }
          >
            Resume
          </Button>
          <IconButton ml={5} mt={7} icon={<FaLinkedin />} isRound="true"
           onClick={()=>
              window.open("https://www.linkedin.com/in/ratnesh-pandey-068771232/")
              }>
            
          </IconButton>
          <IconButton
            ml={5}
            mt={7}
            icon={<FaGithub />}
            isRound="true"
            onClick={()=>
              window.open("https://github.com/pandeyratnesh1997")
            }
          ></IconButton>

          
        </Box>
        <Image
          alignSelf="center"
          mt={notSmallScreen ? "0" : "12"}
          mb={notSmallScreen ? "0" : "12"}
          borderRadius="full"
          background="transparent"
          boxShadow="lg"
          boxSize="300px"
          ml={notSmallScreen ? "10" : "5"}
          src="https://avatars.githubusercontent.com/u/99636772?v=4"
        />
      </Flex>
    </Stack>
  );
};

export default Header;
